import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';

const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const rowsPerPage = 10;

    const fetchNotifications = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) {
                setError('No token found');
                setLoading(false);
                return;
            }

            const response = await axios.get('https://api.safree.org/api-v2022/org-guardian/my/v1/notifications', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setNotifications(response.data.data);
        } catch (err) {
            setError('Error fetching data: ' + err.message);
        } finally {
            setLoading(false);
        }
    };
    const handleClearAll = async () => {
        const confirmClear = window.confirm("Are you sure you want to clear all notifications?");
        if (!confirmClear) return; // If user cancels, exit
    
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setError('No token found');
                return;
            }
    
            await axios.delete('https://api.safree.org/api-v2022/org-guardian/my/v1/clear/notifications', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
            fetchNotifications();
        } catch (err) {
            setError('Error clearing notifications: ' + (err.response?.data?.message || err.message));
        }
    };
    
    
    
    useEffect(() => {
        fetchNotifications();
    }, []);

    const totalPages = Math.ceil(notifications.length / rowsPerPage);
    const currentRows = notifications.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const getPageNumbers = () => {
        const maxPageNumbersToShow = 5;
        const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);
        const pageNumbers = [];

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    if (loading) return <div className='loading'><img src={Loader} alt="Loading..." /></div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container user-management">
            <div className="row header">
                <div className="col-md-6">
                    <p className="sub-heading">Notification Management</p>
                </div>
                <div className="col-md-6">
                <button className="condisp nesp" onClick={handleClearAll}> Clear all</button>
                </div>
            </div>

            <div className="content-wrapper">
                <div className="table-container" style={{ minWidth: "100%", overflowX: "auto" }}>
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Published</th>
                                <th>Created</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((notification, index) => (
                                <tr key={notification.notificationId}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{notification.title}</td>
                                    <td>{notification.description}</td>
                                    <td>{notification.isPublished ? 'Yes' : 'No'}</td>
                                    <td>{new Date(notification.created).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="pagination-container">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('prev')}
                            disabled={currentPage === 1}
                        >
                            &laquo; Prev
                        </button>
                        {getPageNumbers().map((page) => (
                            <button
                                key={page}
                                className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                                onClick={() => setCurrentPage(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('next')}
                            disabled={currentPage === totalPages}
                        >
                            Next &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Notifications;
